module.exports = __webpack_public_path__ + "static/media/crying-cat-svgrepo-com.7c29047b.svg";